import React from 'react';
import { X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import Button from './ui/Button';

const CloseButton = ({ 
  onClose, 
  navigateTo = '/dashboard', 
  className = '',
  variant = 'ghost',
  size = 'sm',
  label = 'Close',
  showLabel = false,
  ariaLabel = 'Close page'
}) => {
  const navigate = useNavigate();

  const handleClose = () => {
    if (onClose) {
      onClose();
    } else {
      navigate(navigateTo);
    }
  };

  return (
    <Button
      onClick={handleClose}
      variant={variant}
      size={size}
      className={`flex items-center justify-center gap-2 min-w-[44px] min-h-[44px] touch-manipulation active:scale-95 transition-transform relative z-[60] bg-white/90 hover:bg-white border-2 border-gray-300 hover:border-gray-400 shadow-lg ${className}`}
      aria-label={ariaLabel}
    >
      <X className="w-6 h-6 text-gray-700" strokeWidth={3} />
      {showLabel && <span className="font-medium text-gray-700">{label}</span>}
    </Button>
  );
};

export default CloseButton;